import { render, staticRenderFns } from "./CarTile.vue?vue&type=template&id=054ad6ad&scoped=true&"
import script from "./CarTile.vue?vue&type=script&lang=ts&"
export * from "./CarTile.vue?vue&type=script&lang=ts&"
import style0 from "./CarTile.vue?vue&type=style&index=0&id=054ad6ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ad6ad",
  null
  
)

export default component.exports